export const getToken = () => localStorage.getItem("token");

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("expiresAt");
  window.location.href = "/login";
};

export const authHeader = () => ({
  Authorization: `Bearer ${getToken()}`,
});
export const isLoggedIn = () => {
  const token = localStorage.getItem("token");
  const expiresAt = localStorage.getItem("expiresAt");

  if (!token || !expiresAt) return false;

  const expiry = new Date(expiresAt);
  if (isNaN(expiry.getTime()) || expiry <= new Date()) {
    logout();
    return false;
  }

  return true;
};
